<script lang="ts">
	import { t } from 'svelte-i18n'
	import { Modality } from '@semanticedge/persistence-service-noheaders-client/src'
	import { Modal } from '@repo/commons/components'
	import type {
		OutputObjectPromptVariantsRequest,
		ProjectViewModel,
		TableData,
		ValidatorFunctionFactory
	} from '@repo/commons/models'
	import type { OutputObjectSubmitHandler } from './types.js'
	import OutputObjectModalContent from './OutputObjectModalContent.svelte'

	type Props = {
		visible: boolean
		onclose: VoidFunction
		project: ProjectViewModel | null
		onSubmit: OutputObjectSubmitHandler
		editingOutputObject?: TableData | null
		existingOutputObjectIds?: readonly string[]
		nameReadOnly?: boolean
		createNameValidator?: (initialName?: string) => ValidatorFunctionFactory
	}

	const {
		project,
		visible,
		onclose,
		onSubmit,
		editingOutputObject,
		existingOutputObjectIds = [],
		nameReadOnly = false,
		createNameValidator
	}: Props = $props()

	let promptVariantsRequest = $state<OutputObjectPromptVariantsRequest | null>(null)
	let selectedModality = $state<Modality>(Modality.Voice)

	const title = $derived(
		promptVariantsRequest
			? $t('OutputObjectModal.promptVariantsTitle')
			: $t('OutputObjectModal.title')
	)

	const handleClose = (): void => {
		promptVariantsRequest = null

		onclose()
	}
</script>

<Modal {title} {visible} onclose={handleClose} showCloseButton={false} closeOnBackdropClick={false}>
	<OutputObjectModalContent
		{project}
		{onSubmit}
		{editingOutputObject}
		bind:selectedModality
		onclose={handleClose}
		{existingOutputObjectIds}
		{nameReadOnly}
		{createNameValidator}
		bind:promptVariantsRequest
	/>
</Modal>
